import { Container, Grid, Typography } from '@mui/material';
// import { Heart } from 'lucide-react';
import getStyles from './styles';

const FinalCTASection = () => {
  const styles = getStyles();

  return (
    <Grid sx={styles.section}>
      <Grid sx={styles.backgroundPattern} />
      <Container maxWidth={'xl'}>
        <Grid sx={styles.container}>
          <Typography variant="h2" sx={styles.title}>
            Becoming a Leader Starts by Taking the First Step.
          </Typography>
          <Typography sx={styles.subtitle}>
            If you&apos;re ambitious, curious, and willing to build — this
            fellowship is for you.
          </Typography>
          <Grid sx={styles.buttonGroup}>
            {/* <Button
              variant="contained"
              size="large"
              sx={styles.themeBtn}
              endIcon={
                <Heart
                  style={{ width: '20px', height: '20px', marginLeft: '8px' }}
                />
              }
            >
              Get Notified
            </Button> */}
            {/* <Button variant="outlined" size="large" sx={styles.outlineBtn}>
              Download Program Brochure
            </Button> */}
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default FinalCTASection;
